// extracted by mini-css-extract-plugin
export default {"Container":"LessonsPage_Container__d3bGr","Intro":"LessonsPage_Intro__HVdjI","BubbleContainer":"LessonsPage_BubbleContainer__dRUtm","Content":"LessonsPage_Content__Ez94+"};